//Orders Data
export const GET_GENERAL_ORDERS_LIST = "GET_GENERAL_ORDERS_LIST";
export const GET_NEW_ORDERS_LIST = "GET_NEW_ORDERS_LIST";
export const GET_CANSHIPP_ORDERS_LIST = "GET_CAN_SHIPP_ORDERS_LIST";
export const GET_DRAFT_HOURS_LIST = "GET_DRAFT_HOURS_LIST";
export const GET_MAW_ORDERS_LIST = "GET_MAW_ORDERS_LIST";
export const GET_REFERENCE_ORDERS_LIST = "GET_REFERENCE_ORDERS_LIST";


//Orders options in the filters
export const GET_GENERAL_ORDERS_OPTIONS = "GET_GENERAL_ORDERS_OPTIONS";